import React, { useRef } from 'react';
import emailjs from 'emailjs-com';
import { Form } from 'react-bootstrap';
import './Contact.css'
const Contact = () => {
    const form = useRef();

    const sendEmail = (e) => {
        e.preventDefault();

        emailjs.sendForm('service_x3lqy2t', 'template_iuesinp', form.current, 'user_BvMDeFTlbwwZiqnYv0S8b')
            .then((result) => {
                console.log(result.text);
            }, (error) => {
                console.log(error.text);
            });
        e.target.reset()
    };
    return (
        <div>
            <form className="desing-contact bg-light shadow-lg p-3 mb-5 bg-body rounded" ref={form} onSubmit={sendEmail}>

                <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
                    <Form.Label>Write your name</Form.Label>
                    <Form.Control type="text" name="name" placeholder="your name" />
                </Form.Group>
                <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
                    <Form.Label>Email address</Form.Label>
                    <Form.Control type="email" placeholder="name@gmail.com" />
                </Form.Group>
                <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
                    <Form.Label>Write your subject</Form.Label>
                    <Form.Control type="text" name="subject" placeholder="your subject" />
                </Form.Group>
                <Form.Group className="mb-3" controlId="exampleForm.ControlTextarea1">
                    <Form.Label> write your massage </Form.Label>
                    <Form.Control as="textarea" rows={3} />
                </Form.Group>


                <input type="submit" value="Send" />
            </form>
        </div>

    );
};

export default Contact;